<div class="row">
  <div class="titleblock">
    <h3 class="title1level">Inserisci nuovo documento</h3>
  </div>
</div>
<div class="row margin-form">
  <form #f="ngForm" [formGroup]="aggiungiDocumentoForm">
    <ng-template [ngIf]="!isFolder">
      <div class="row">
        <div textInput class="col-sm-6" [labelInput]="'Titolo'" [control]="aggiungiDocumentoForm.controls['titolo']"
          formControlName="titolo" [(ngModel)]="formRequest.titolo" [mandatory]="true"></div>
        <div ng-select-combo class="col-sm-6" formControlName="provenienza" [label]="'Provenienza'" [required]="true"
          [options]="tipiProvenienza" [optionSel]="formRequest.provenienza" [disabled]="atto"
          (onChangeSel)="formRequest.provenienza = $event; aggiungiDocumentoForm.controls['provenienza'].setValue($event);">
        </div>
      </div>
      <div class="row">
        <div ng-select-combo class="col-sm-6" formControlName="tipoDocumento" [label]="'Tipo'" [required]="true"
          [options]="tipiDocumento" [optionSel]="formRequest.tipoDocumento" [disabled]="false"
          (onChangeSel)="formRequest.tipoDocumento = $event; aggiungiDocumentoForm.controls['tipoDocumento'].setValue($event);">
        </div>
        <div datePickerInput class="col-sm-6" [labelInput]="'Data riferimento'" formControlName="dataRiferimento"
          [(ngModel)]="formRequest.dataRiferimento" [mandatory]="true"
          [control]="aggiungiDocumentoForm.controls['dataRiferimento']"></div>
      </div>
      <div class="row">
        <div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note" [(ngModel)]="formRequest.note">
        </div>
      </div>

      <div class="row d-flex justify-content-center mx-10" style="margin-top: 20px !important">
        <div class="dropzone">
          <div class="text-wrapper">
            <span class="glyphicon glyphicon-upload" style="font-size: 30px;margin-left:140px;margin-top:30px"></span>
            <div class="centered" style="margin-top:10px;margin-left:85px">Trascina i file qui <br> o <br></div>

            <div class="upload-btn-wrapper" id="target" style="cursor: pointer;margin-left: 102px">
              <button class="btn btn-primary btn-block" style="cursor: pointer">Seleziona file</button>
              <input type="file" name="myfile" (change)="onSearchChange($event)" style="cursor: pointer;" multiple />
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="fileUploadList && fileUploadList.length > 0" class="row mx-20 d-flex justify-content-center" >
        <div class="col-sm-12 col-xs-12">
          <table class="tg margin-uploaded">
            <tr *ngFor="let item of fileUploadList; let index = index">
              <th class="tg-oy1f">
                {{item.nomeFile}}<span style="text-align: center;color:#0b59a4;cursor: pointer; margin-left:5px;" class="glyphicon glyphicon-trash"
                  (click)="deleteFile(fileUploadList.splice(index, 1))"></span>
              </th>
            </tr>
          </table>
        </div>

      </div>
      <div class="row">
        <p class="mandatory col-sm-12">
          <em>* Campi obbligatori</em>
        </p>
      </div>
      <div class="row stepper-border-bottom-mb-15">
        <p class="col-sm-3 col-xs-6">
          <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset();">Annulla</button>
        </p>
        <p submitButton class="col-xs-6 col-sm-offset-3" (click)="save();"
          [labelButton]="'Inserisci documento'"
          [disabled]="!formRequest.titolo || !formRequest.provenienza || !formRequest.tipoDocumento || !formRequest.dataRiferimento || fileUploadList.length === 0">
        </p>
      </div>
    </ng-template>
  </form>
</div>
